import React, { useEffect, useState } from "react";
import _ from "lodash"
import Button from "ui/Button";
import { InlineLoading, InlineNotification, Modal, ModalBody, ModalFooter } from "carbon-components-react";
import Input from "forms/inputs/Input";
import Skeleton from "forms/inputs/Skeleton";
import client from "client/client";
import { consoleLog } from "utils/functions";
import classNames from "classnames";

// Avoid rendering
// let values = {};
let rules = {};
// let loaded = false;

const Form = (props) => {
  /**
   * Field values
   */
  const [values, setValues] = useState({}); // Comment to avoid rendering
  // const setValues = (newValues) => {
  //   values = newValues;
  // };
  /**
   * Validation errors
   */
  const [errors, setErrors] = useState({});

  /**
   * Loaded data indicator
   */
  const [loaded, setLoaded] = useState(false); // Comment to avoid rendering
  // const setLoaded = (newLoaded) => {
  //   loaded = newLoaded;
  // };
  /**
   * Set the list of touched fields
   */
  const [touched, setTouched] = useState([]);

  /**
   * Set the list of validation rules
   */
  //   const [rules, setRules] = useState([]); // Comment to avoid rendering
  const setRules = (newRules) => {
    rules = newRules;
  };

  /**
   * Element ID
   */
  const [itemId, setItemId] = useState(null);

  /**
   * Saving indicator. Set to `true` when form is sendig data to backend
   */
  const [saving, setSaving] = useState(false);

  const [showingFeedback, setShowingFeedback] = useState(false);

  /**
   * Set to `true` when backend returns correct response
   */
  const [savingSuccess, setSavingSuccess] = useState(false);

  /**
   * Set to `true` when backend returns an error
   */
  // const [savingErrors, setSavingErrors] = useState(false);

  /**
   * Set to `true` when backend returns an error in order to call `clearErrors` method as soon as a user touch an input field
   */
  const [sentWithErrors, setSentWithErrors] = useState({});

  /**
   * Set to `true` when backend returns an error in order to call `clearErrors` method as soon as a user touch an input field
   */
  const [formErrorsModalOpen, setFormErrorsModalOpen] = useState(false);

  /**
   * Initialize values and rules arrays
   */
  useEffect(() => {
    if (!_.isEmpty(touched) && props.blockTouched) {
      return false
    }
    let fields = {};
    // let rules = {};
    let formFields = props.fields || []
    if (!formFields?.length) {
      props.sections?.forEach(element => {
        formFields = formFields.concat(element.fields)
      });
    }
    // console.log("formFields", formFields)
    formFields.forEach((element) => {
      if (!_.isEmpty(element.id)) {
        // console.log("Form", element.id, element.value)
        fields = {
          ...fields,
          [element.id]: element.value,
        };
        // if (element.rules) {
        //   rules = {
        //     ...rules,
        //     [element.id]: element.rules,
        //   };
        // }
      }
    });
    if (!props.modal) {
      setSentWithErrors({})
    }
    setValues(fields);
    // setRules(rules);
  }, [props.fields, props.sections]);

  useEffect(() => {
    if (!props.blockTouched) {
      setTouched([]);
    }
  }, [props.defaultParams]);

  useEffect(() => {
    // setLoaded(true);
    setLoaded(props.loaded);
  }, [props.loaded]);

  useEffect(() => {
    setItemId(props.itemId)
    setTouched([])
  }, [props.itemId]);

  const onSubmit = async (e, forceParams) => {
    const params = forceParams || cleanValues()

    if (props.skipActions) {
      if (props.onSubmit) {
        props.onSubmit(params)
      }
      return false
    }
    clearStatus()
    onSavingChange(true)
    let res = null

    try {
      if (((itemId && itemId !== "new") || props.method === "put") && !props.forceEndpoint) {
        res = await client.put([props.endpoint, itemId].join("/"), params);
      } else {
        res = await client.post(props.endpoint, params);
      }
      if (res.data) {
        setSavingSuccess(true);
        if (props.checkMetas) {
          props.checkMetas(res.data.meta)
        }
        if (props.onSubmit) {
          const evtData = (props.isLogin) ?
            res.data : res.data.data
          props.onSubmit(evtData)
        }
        if (props.setAutoId) {
          consoleLog("res.data.data.id", res.data.data.id)
          setItemId(res.data.data.id)
        }
        setTouched([])
      } else {
        // setSavingErrors(true);
      }
    }
    catch (e) {
      consoleLog("Catch Event", e)
      let errorMessage = window._.get(e, "response.data.errors") || [window._.get(e, "response.data.message")]
      consoleLog("errorMessage", errorMessage)
      openErrorsModal(errorMessage)
    }
    finally {
      onSavingChange(false)
      setShowingFeedback(true)
      window.setTimeout(() => {
        setShowingFeedback(false)
      }, 2000);
    }
    // setTouched([])

  };

  const onSavingChange = (value) => {
    setSaving(value)
    if (props.onSavingChange) {
      props.onSavingChange(value)
    }
  }

  const openErrorsModal = (errors) => {
    consoleLog("openErrorsModal", errors)
    setSentWithErrors(errors)
    setSavingSuccess(false);
    if (!props.modal) {
      setFormErrorsModalOpen(true)
    }
  }

  const onErrorsModalRequestClose = () => {
    setFormErrorsModalOpen(false)
  }

  const cleanValues = (forceValues) => {
    let consistentValues = {}
    Object.keys(values).forEach(key => {
      if (values[key] !== null) {
        consistentValues = {
          ...consistentValues,
          [key]: values[key]
        }
      }
    })
    const params = forceValues || values
    const cleaned = (props.cleanValues) ?
      props.cleanValues(params) : params

    return {
      ...cleaned,
      ...props.defaultParams
    };
  };

  /**
   * Handle field change Event. Called when user changes manually single field value
   *
   * @param {Event} e
   * @param {String} name
   * @param {Boolean} skipTouch
   */
  const handleChange = (e, name, skipTouch) => {
    let value = null;
    if (e?.target) {
      value = e.target.value;
      if (e.target.type === "checkbox") {
        value = (value === "on")
      }
    } else if (e?.selectedItem === null) {
      value = null;
    } else if (e?.selectedItem) {
      value = e.selectedItem.id;
    } else if (e?.selectedItems) {
      value = e.selectedItems.map((item) => item.id);
    } else {
      value = e;
    }

    // Clear errors if is the first time user touches something after clicked `save` button
    if (sentWithErrors) {
      clearErrors();
      setSentWithErrors({});
    }
    setValue(name, value);
    if (!skipTouch) {
      touch(name, value);
    }
    if (props.onChange) {
      props.onChange(name, value)
    }
    if (props.saveOnChange) {
      if (itemId && (!_.isEmpty(touched) || !skipTouch)) {
        if (!_.isEmpty(Form.timeouts) && Form.timeouts[itemId]) {
          window.clearTimeout(Form.timeouts[itemId])
        }
        Form.timeouts[itemId] = window.setTimeout(() => onSubmit(null, editValues(name, value)), 1200)
      }
    }
  };

  const editValues = (name, value) => {
    const newValues = (name) ? {
      ...values,
      [name]: value,
    } : values
    return cleanValues(newValues)
  }

  const getFormattedErrors = () => {
    return Object.values(sentWithErrors)
  }

  // const setValue = (name, value, args) => {
  //   console.log("setValue", name, value, {
  //     ...values,
  //     [name]: value,
  //   })
  //   setValues({
  //     ...values,
  //     [name]: value,
  //   });
  // };
  const setValue = (name, value) => {
    // console.log("touchsetvalue", name, value, {
    //   ...values,
    //   [name]: value,
    // })
    setValues({
      ...values,
      [name]: value,
    });
  };

  const getValue = (name) => {
    return values ? values[name] : "";
  };


  const clearErrors = () => {
    setErrors({});
  };

  /**
   * Reset all status
   */
  const clearStatus = () => {
    setSavingSuccess(false);
    // setSavingErrors(false);
    setSentWithErrors({});
    onSavingChange(false);
  };

  /**
   * Updated touched fields list
   *
   * @param {String} name
   * @param value
   */
  const touch = (name, value) => {
    setTouched({
      ...touched,
      [name]: value,
    });
    if (props.onTouch) {
      props.onTouch(name, value)
    }
  };

  const getSectionFields = (sectionFields) => {
    return sectionFields.map((attributes) => {
      let { value, id, autoComplete, ...item } = attributes;
      const keyPostfix = (itemId) ? [itemId, id].join("-") : id
      if (loaded) {
        let itemProps = {
          ...item,
          id: keyPostfix,
          name: keyPostfix,
          onChange: (e, skipTouch) => {
            if (attributes.onChange) {
              attributes.onChange(e, skipTouch)
            }
            handleChange(e, id, skipTouch)
          },
          compareValues: props.compareValues,
          original: attributes.original,
          invalid: attributes.invalid ? attributes.invalid : sentWithErrors ? sentWithErrors[id]?.length > 0 : false,
          invalidText: attributes.invalidText ? attributes.invalidText : sentWithErrors ? sentWithErrors[id]?.join(", ") : null,
          defaultValue: attributes.value,
          value: getValue(id),
          autoComplete: autoComplete
        };

        return <Input {...itemProps} key={"form-element" + keyPostfix} />;
      } else {
        return <Skeleton {...item} key={"form-element" + keyPostfix} />;
      }
    });
  }

  const getFormSection = (section) => {
    return !section.hidden && (
      <section className="form-section" key={`form-section-${section.id}`}>
        {
          section.label && (
            <h4 className={classNames("form-section__label", {
              "form-section__label--noborder": section.noBorder
            })}>{section.label}</h4>
          )
        }
        {getSectionFields(section.fields)}
      </section>
    )
  }

  const getFields = () => {

    if (props.fields) {
      return getSectionFields(props.fields)
    }
    const formSections = props.sections || [{
      id: undefined
    }]

    return formSections.map(section => getFormSection(section))
  };

  const submitButtonDisabled = () => {
    return !loaded || props.submitButtonDisabled //  || _.isEmpty(touched)
  }

  let buttonContent = (
    <Button
      // size="field"
      onClick={onSubmit}
      disabled={submitButtonDisabled()}>
      Save
    </Button>
  )

  if (saving) {
    buttonContent = <InlineLoading
      className="light"
      description={props.postingMessage || "Saving..."}
      status="active"
    />;
  }
  else if (showingFeedback) {
    if (savingSuccess) {
      buttonContent = <InlineLoading
        className="light"
        description={props.afterPostOKMessage || "Saved"}
        status="finished"
      />;
    } else if (sentWithErrors !== {}) {
      buttonContent = <InlineLoading
        className="light"
        description={props.afterPostKOMessage || "Error"}
        status="error"
      />;
    }
  }


  const getSecondaryButtonText = () => {
    return props.hideCloseButton ? null : "Cancel"
  }

  const modalFooter = () => {
    return (
      <ModalFooter
        className="form-modal__footer"
        primaryButtonText={`${saving ? "Saving..." : props.primaryButtonText || "Save"}`}
        secondaryButtonText={getSecondaryButtonText()}
        onRequestSubmit={onSubmit}
        closeModal={props.onRequestClose}
        primaryButtonDisabled={submitButtonDisabled() || saving}
        danger={props.danger}
      />
    )
  }


  if (!props.modal) {
    const abortButton = (props.abortButton && props.onAbortClicked) ? (
      <Button kind="danger--tertiary" onClick={props.onAbortClicked}>Cancel</Button>
    ) : null

    const buttons = (!props.hideSubmitButton) ? (
      <div className={classNames("form-footer", {
        "fixed-footer": !props.hasStandardFooter
      })}>{buttonContent}{abortButton}</div>
    ) : null

    return (
      <>
        {
          props.extraContents
        }
        <form onSubmit={onSubmit}>
          {getFields()}
          {props.extraFieldsAfter}
          {buttons}
        </form>
        <Modal
          open={formErrorsModalOpen}
          // danger={true}
          passiveModal={true}
          // onRequestSubmit={() => onModalRequestSubmit()}
          onRequestClose={onErrorsModalRequestClose}
          // onSecondarySubmit={() => onModalRequestClose()}
          primaryButtonText="Continue"
          secondaryButtonText="Cancel"
          modalHeading={"Something went wrong!"}
          size="sm"
        >
          {
            sentWithErrors ? getFormattedErrors().map((item, index) => <div key={`form-error=${index}`}>{item}</div>) : null
          }
        </Modal>
      </>
    );
  }
  else {
    return (
      <>
        <ModalBody className="form-modal__body">
          {
            props.extraContents
          }
          {
            getFormattedErrors().length ? ( // 
              <div style={{ paddingBottom: "1rem" }}>
                <InlineNotification
                  kind="error" lowContrast={true} hideCloseButton={true} title="" subtitle="Something went wrong"
                // subtitle={getFormattedErrors().map((item, index) => <div key={`form-error=${index}`}>{item}</div>)}
                />
              </div>
            ) : null
          }
          <form onSubmit={onSubmit}>
            {getFields()}
          </form>
          {props.extraFieldsAfter}
        </ModalBody>
        {modalFooter()}
      </>
    );
  }

};

Form.timeouts = []

export default Form;
